import { render, staticRenderFns } from "./Statistical_Into.vue?vue&type=template&id=46382945&scoped=true&"
import script from "./Statistical_Into.vue?vue&type=script&lang=js&"
export * from "./Statistical_Into.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46382945",
  null
  
)

export default component.exports